var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 6.1 5.5 7.5 6.9 5 5.5 2.5 8 3.9l2.5-1.4L9.1 5l1.4 2.5zm12 9.8 2.5-1.4-1.4 2.5 1.4 2.5-2.5-1.4-2.5 1.4 1.4-2.5-1.4-2.5zm2.5-13.4L21.1 5l1.4 2.5L20 6.1l-2.5 1.4L18.9 5l-1.4-2.5L20 3.9zm-8.66 10.78 2.44-2.44-2.12-2.12-2.44 2.44zm1.03-5.49 2.34 2.34c.39.37.39 1.02 0 1.41L5.54 23.21c-.39.39-1.04.39-1.41 0l-2.34-2.34c-.39-.37-.39-1.02 0-1.41L13.46 7.79c.39-.39 1.04-.39 1.41 0"
})));
export { SvgMagic as ReactComponent };
export default __webpack_public_path__ + "f513d09c23c61acf3c168ec67c3a4c61.svg";